const ColumnSize = [
  { smallSize: true },
  {
    size: '150', smallSize: true, textCenter: true, textLowercase: true,
  },
  { size: '60', smallSize: true, textRight: true },
];

export default ColumnSize;
